export default function resolveCountryName(
  countryCode: string,
  locale: string,
) {
  try {
    return new Intl.DisplayNames([locale], { type: "region" }).of(countryCode);
  } catch (error) {
    return countryCode;
  }
}
